export enum ColorScheme {
  BlueGreen,
  RedPurple,
  PurpleBlue,
  WarnNeutral,
  Executive,
  ColorBlind,
  Greyscale
}